export default "<p>{{rows}}</p>\r\n";